import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "product-page" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "desc" }
const _hoisted_5 = ["onClick"]

import { useRouter } from 'vue-router' 

export default /*@__PURE__*/_defineComponent({
  __name: 'Product',
  setup(__props) {

const router = useRouter()

const productList = [
  {
    title: "智慧法规库",
    description: "覆盖全球100+国家医疗器械法规，收录超50万条实时更新数据，助力企业高效合规，缩短产品上市周期30%以上。",
    path: 'law'
  },
  {
    title: "医疗器械行业数据",
    description: "涵盖超20万家企业和10万种产品，年更新数据超100万条，助力精准市场分析和决策支持。",
    path: 'medicalData'
  },
  {
    title: "行业资讯跟踪",
    description: "覆盖超500家权威媒体，年发布资讯逾10万条，助您实时掌握行业动态与市场趋势。",
    path: 'industryNews'
  },
  {
    title: "多语言文件转换",
    description: "准确度高达85%，支持50+语种，日均处理超10万字，轻松跨越语言障碍，沟通无国界。",
    path: 'language'
  },
  {
    title: "医疗器械注册服务",
    description: "服务近20家械企，提供从研发立项、注册申报到上市后变更的全生命周期法规管理。更结合自研AI工具，智能预警法规变化、优化申报策略，显著提升合规效率与成功率。",
    path: 'medicalRegister'
  },
]

const toPath = (path: any) => {
  if (path) {
    router.push({
      name: path 
    })
  }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"top-banner\" data-v-15960fe9><img src=\"https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/banner2.png\" alt=\"Banner\" class=\"banner-image\" data-v-15960fe9><div class=\"banner-info\" data-v-15960fe9><div class=\"label\" data-v-15960fe9>智守合规</div><div class=\"label em\" data-v-15960fe9>械准无忧</div></div></div>", 1)),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productList, (item, i) => {
      return _createElementVNode("div", {
        class: _normalizeClass(["product-item", `type${i + 1}`]),
        key: i
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(item.description), 1),
          _createElementVNode("div", {
            class: "btn",
            onClick: ($event: any) => (toPath(item.path))
          }, "了解更多", 8, _hoisted_5)
        ])
      ], 2)
    }), 64))
  ]))
}
}

})